import React, { useEffect, useState, useRef } from "react";
import Header from "../components/Header";
import { BsChevronRight } from "react-icons/bs";
import { Link } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import { useAxios } from "../services/useAxios";
import Nodata from "../components/NoData";
import { set } from "date-fns";

export default function NoticeList() {
    const { t } = useTranslation();
    const [data, setData] = useState({});
    const [request] = useAxios();
    const [page, setPage] = useState(0);

    const [dataInfo, setDataInfo] = useState({});
    const [dataList, setDataList] = useState([]);

    const fetchData = async (page) => {
        const response = await request.post("/app/mypage/getBbsNttListAPI", {
            bbsSn : 1,
            pageIndex : page
        });

        if(response.data.resultCode === 200){
            console.log(response.data)
            setData(response.data.result);
            setDataList((prevData) => [...prevData, ...response.data.result.resultList]);            
        }
    };

    const handleObserver = (entries) => {
        const target = entries[0];
        if (target.isIntersecting ) {
            setPage((prevPage) => prevPage + 1);
        }
      };
      const fn_handleBack = () => {
        setDataInfo({})
      }

    useEffect(() => {
        if(page > 0){
            fetchData(page);    
        }
      }, [page]);
    
    
     
    
      useEffect(() => {
        const observer = new IntersectionObserver(handleObserver, {
          threshold: 0, //  Intersection Observer의 옵션, 0일 때는 교차점이 한 번만 발생해도 실행, 1은 모든 영역이 교차해야 콜백 함수가 실행.
        });
        // 최하단 요소를 관찰 대상으로 지정함
        const observerTarget = document.getElementById("observer");
        // 관찰 시작
        if (observerTarget) {
          observer.observe(observerTarget);
        }
      }, []);

    return (
        <div>
                {!dataInfo.nttSn?(
                 <>
                <div className="backGround bgBlue"></div>
                <Header type="cart"  pageTitle={t(`Message.notice_bbs_list_title`)}/>
                
                
                {dataList && dataList.length === 0?(
                
                <div className="floatCenter">
                    <Nodata text={t(`Message.notice_bbs_list_empty`)}/>
                </div> 
                ):(
                    <>
                <div className="noticeList">
                 {dataList && dataList.map((obj, index) => (
                 <Link key={index} onClick={(e)=> setDataInfo(obj) } className="noticeTitWr">
                    <div className="dfColG8">
                        <p className="title">{obj.nttSj}</p>
                        <p className="date">{obj.frstRegistPnttm}</p>
                    </div>
                    <BsChevronRight className="arrow" />
                </Link>
                ))}      

                      
                </div>
                
                </>
                )}
             <div id="observer" style={{ height: "10px" }}></div>    

             </>
             ):(
                <>
                <Header type="black" handleBack={fn_handleBack}  pageTitle={t(`Message.notice_bbs_list_title`)}/>
                <div className="noticeViewTitWr">
                    <p className="tit">{dataInfo.nttSj}</p>
                    <p className="date">{dataInfo.frstRegistPnttm}</p>
                </div>
                <div className="noticeArea" >
                    <div dangerouslySetInnerHTML={{ __html: dataInfo.nttCn }}>

                    </div>
                

                    <Link onClick={fn_handleBack} className="btn40 bdd fw600 mt40">{t(`Message.notice_bbs_list_move_list`)}</Link>
                </div>
                </>
             )}
           
        </div>
    );
};